export default "__VITE_ASSET__a1790656__"